import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';

import { SharedModule } from '../../_shared/shared.module';
import { AlertService } from '../../_shared/services/alert.service';
import { UtilService } from '../../_shared/services/util.service';

import { Currency } from '../shared/currency.model';
import { CurrencyModalService } from '../shared/currency-modal.service';
import { CurrencyService } from '../shared/currency.service';

@Component({
  selector: 'app-currency-detail',
  templateUrl: './currency-detail.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class CurrencyDetailComponent implements OnInit {
  constructor(
    private currencyService: CurrencyService,
    private currencyModalService: CurrencyModalService,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private utilService: UtilService
  ) {}

  @Input() currency: Currency;
  @Input() mode: string;
  @Input() defaultLanguage;
  @Input() additionalLanguages;
  @Input() isModal = false;

  @Output() private savedCurrency = new EventEmitter<Currency>();
  @Output() private canceledCurrency = new EventEmitter();

  form: FormGroup;
  formSubmited = false;

  createMode = false;
  editMode = false;
  viewMode = false;

  serverErrors = [];
  sendingForm = false;

  decimalPlaces = [0, 2, 3, 4];

  private currencyCopy;

  ngOnInit() {
    this.setCurrencyForm();

    if (this.currency.id) {
      this.setItemOptions(this.currency, this.mode);

      this.form.patchValue(this.currency);
    } else {
      this.createMode = true;
    }
  }

  // Referenced from app-translation-options
  onOpenedTranslation(language) {
    this.currencyModalService.openCurrencyTranslation(this.currency, language);
  }

  // Referenced from app-item-detail-form-actions
  onSavedCurrency() {
    this.formSubmited = true;

    if (this.form.invalid) {
      this.serverErrors = [];

      return;
    }

    const formData = this.form.value;

    const fields = ['name', 'code', 'symbol', 'decimal_places'];

    if (this.editMode && !fields.some((field) => formData[field] !== this.currencyCopy[field])) {
      this.onCanceled();
      return;
    }

    // console.log(formData);
    // return;

    this.sendingForm = true;

    this.currencyService
      .saveCurrency(this.currency.id, formData, this.defaultLanguage.lang)
      .subscribe({
        next: (response) => {
          let msg = '';

          if (this.editMode) {
            msg = 'MODIFIED_CATEGORY';

            // needed if we want to keep the page opened or if used in page
            this.currency = response;
            this.setItemOptions(response);
          } else {
            msg = 'NEW_ADDED_CATEGORY';
            // this.currency = response; // reload item - needed ?
          }

          this.alertService.open(msg);

          // this.setItemOptions(response);

          this.sendingForm = false;

          this.savedCurrency.emit(response);
        },
        error: (response) => {
          this.serverErrors = this.utilService.setFormServerErrors(response.error.errors);

          this.sendingForm = false;
        },
      });
  }

  // Referenced from app-item-detail-form-actions
  onCanceled() {
    // if (this.editMode) {
    //   this.cancelEdit();
    //   return;
    // }

    this.canceledCurrency.emit();
  }

  // Referenced from app-item-detail-form-actions
  onEditedCurrency() {
    this.editMode = true;
    this.viewMode = false;
  }

  // private cancelEdit() {
  //   this.currency = this.currencyCopy;
  //   this.setItemOptions(this.currency);
  // }

  private setItemOptions(currency, mode = '') {
    this.createMode = false;
    this.editMode = false;
    this.viewMode = true;

    if (mode === 'edit') {
      this.onEditedCurrency();
    }

    this.currencyCopy = { ...currency };
  }

  private setCurrencyForm() {
    this.form = this.formBuilder.group({
      name: [
        // { value: '', disabled: true },
        '',
        {
          validators: [
            Validators.required,
            // Validators.maxLength(100), used it in html to limit the input length
            // Validators.pattern(this.utilService.selectInputPattern('text')), // Problems with German characters
          ],
          updateOn: 'blur',
        },
      ],
      code: [
        // { value: '', disabled: true },
        '',
        {
          validators: [
            Validators.required,
            // Validators.maxLength(5), used it in html to limit the input length
            // Validators.pattern(this.utilService.selectInputPattern('text')),
          ],
          updateOn: 'blur',
        },
      ],
      symbol: [
        // { value: '', disabled: true },
        '',
        {
          validators: [
            Validators.required,
            // Validators.maxLength(3), used it in html to limit the input length
            // Validators.pattern(this.utilService.selectInputPattern('text')),
          ],
          updateOn: 'blur',
        },
      ],
      decimal_places: [
        '',
        {
          validators: [Validators.required],
        },
      ],
    });
  }
}
